import { formatDollarAmount } from '@hero/hero-utils/currency';
const getUserCreditFormatted = (amount) => amount !== undefined ? formatDollarAmount(-amount, true) : '-';
export default getUserCreditFormatted;
